import QueryRule from '~/scripts/services/model/query-rule';
import QueryWhereChild from '~/scripts/services/model/query-where-child';
import QueryHaving from '~/scripts/services/model/query-having';
import QueryWhereRule from '~/scripts/services/model/query-where-rule';

export default class QueryRuleHavingController {
	/* @ngInject */
	/**
	 * @param {import('angular').ITimeoutService} $timeout
	 */
	constructor($timeout) {
		this.$timeout = $timeout;

		/** @type {Function | undefined} */
		this.change = undefined;

		/** @type {boolean} */
		this.disabled = false;

		/** @type {any} */
		this.having = null;

		/** @type {import('~/scripts/services/model/query-having').default[]} */
		this.having_aggregates = [
			new QueryHaving({
				aggregate: 'count',
				operator:  'none',
				value:     null,
				type:      null,
			}),

			new QueryHaving({
				aggregate: 'count',
				operator:  'greater_or_equal',
				value:     1,
				type:      'number',
			}),

			new QueryHaving({
				aggregate: 'count',
				operator:  'between',
				value:     [1, 2],
				type:      'number',
			}),

			new QueryHaving({
				aggregate: 'count',
				operator:  'less_or_equal',
				value:     1,
				type:      'number',
			}),
		];

		/** @type {?(QueryWhereChild | QueryRule)} */
		this.rule = null;

		/** @type {?import('../query-builder-children/query-builder-children.controller').default} */
		this.tree = null;
	}

	getHavingAggregates() {
		return (this.rule instanceof QueryRule && this.rule?.path?.length > 1)
			|| this.rule instanceof QueryWhereRule
			|| this.rule instanceof QueryWhereChild ? this.having_aggregates : [];
	}

	/**
	 * @param {any} t
	 * @returns {string} translation
	 */
	getText(t) {
		return t ? `query.having-aggregates.${t.aggregate}_${t.operator}` : 'query.having-aggregates.none';
	}

	/**
	 * @param {import('~/scripts/services/model/query-having').default | undefined} having
	 */
	update(having) {
		this.having = having
			? this.having_aggregates.find(
				aggregate => aggregate.aggregate === having.aggregate && aggregate.operator === having.operator,
			)
			: null;
		if (typeof this.change === 'function') {
			this.change();
		}
	}

	$onInit() {
		if (
			this.rule instanceof QueryRule
			&& (this.rule.path?.length === 1 || this.rule.path === undefined)
		) {
			this.having = undefined;
			if (typeof this.change === 'function') {
				this.change();
			}
		}
	}
}
